"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.performInstantScroll = void 0;
/**
 * Instantly (rather than smoothly) scroll the given element.
 * This is necessary because globals.scss has set scroll-behavior globally. If we've removed that configuration,
 * this function can be replaced with direct calls to window.scrollTo.
 *
 * @param elToScroll usually window
 * @param position the top and/or left position to scroll to
 */
var performInstantScroll = function (elToScroll, position) {
    var htmlEl = document.querySelector('html');
    // set up an instant scroll
    if (htmlEl)
        htmlEl.style.scrollBehavior = 'auto';
    // perform the scroll
    elToScroll.scrollTo(position);
    // reset scroll-behavior to what it's set to in globals.scss
    if (htmlEl)
        htmlEl.style.scrollBehavior = 'smooth';
};
exports.performInstantScroll = performInstantScroll;
